function initUpsellInfiniteScroll() {
  const wrapper = document.getElementById('upsell-scroll-wrapper');
  if (!wrapper) return;

  if (wrapper.dataset.scrollInit === 'true') return;
  wrapper.dataset.scrollInit = 'true';

  const speed = 0.4;
  let isPaused = false;
  let pauseTimeout = null;

  const content = wrapper.innerHTML;
  wrapper.innerHTML = content + content;
  let sectionWidth = wrapper.scrollWidth / 2;

  wrapper.scrollLeft = sectionWidth / 2;

  function animate() {
    if (!isPaused) {
      wrapper.scrollLeft += speed;

      if (wrapper.scrollLeft >= sectionWidth) {
        wrapper.scrollLeft -= sectionWidth / 2;
      } else if (wrapper.scrollLeft <= 0) {
        wrapper.scrollLeft += sectionWidth / 2;
      }
    }
    requestAnimationFrame(animate);
  }

  const pauseScroll = (ms = 2000) => {
    isPaused = true;
    clearTimeout(pauseTimeout);
    pauseTimeout = setTimeout(() => (isPaused = false), ms);
  };

  const prevBtn = document.querySelector('.upsell-arrow.prev');
  const nextBtn = document.querySelector('.upsell-arrow.next');

  if (prevBtn && nextBtn) {
    const scrollStep = wrapper.clientWidth * 0.8;

    prevBtn.addEventListener('click', () => {
      pauseScroll();
      wrapper.scrollBy({ left: -scrollStep, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      pauseScroll();
      wrapper.scrollBy({ left: scrollStep, behavior: 'smooth' });
    });
  }

  wrapper.addEventListener('mouseenter', () => (isPaused = true));
  wrapper.addEventListener('mouseleave', () => (isPaused = false));
  wrapper.addEventListener('touchstart', () => (isPaused = true), { passive: true });
  wrapper.addEventListener('touchend', () => pauseScroll(), { passive: true });
  wrapper.addEventListener('wheel', () => pauseScroll(), { passive: true });

  requestAnimationFrame(animate);
}

document.addEventListener('DOMContentLoaded', initUpsellInfiniteScroll);

document.addEventListener('shopify:section:load', initUpsellInfiniteScroll);
try {
  if (window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(initUpsellInfiniteScroll, 800);
    });
  }
} catch (_) {}
